import { Enum } from '@lighthouse/tools'

import type { AnchorProtocol, BackgroundNoImageProtocol, BaseBreakPointProtocol, CursorProtocol, Direction } from '../../protocols'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export const DIVIDER_STYLE = Enum('DASHED', 'SOLID')
export type DividerStyle = Enum<typeof DIVIDER_STYLE>

export interface DividerBlockConfig extends BaseBreakPointProtocol, AnchorProtocol {
    visible: boolean
    direction?: Direction
    style?: DividerStyle
    fill?: BackgroundNoImageProtocol
    size?: number
    cursor?: CursorProtocol
}

export abstract class DividerBlockAbstract extends BaseBlock {
    type = BlockType.divider

    abstract override config: DividerBlockConfig
}
